import { AnyAction } from 'redux';
import { types } from './meloAttribute.actions';
import { MeloAttributeStateType } from './meloAttribute.types';

const initialState: MeloAttributeStateType = { saving: false, error: false, conflict: false, stale: false };

const reducer = (state = initialState, action: AnyAction): MeloAttributeStateType => {
    switch (action.type) {
        case types.CREATE_MELO_ATTRIBUTE:
        case types.UPDATE_MELO_ATTRIBUTE:
        case types.DELETE_MELO_ATTRIBUTE:
            return { ...state, saving: true, error: false, conflict: false, stale: false };
        case types.MELO_ATTRIBUTE_SAVE_DONE:
            return { ...state, saving: false, error: false, conflict: false, stale: false };
        case types.MELO_ATTRIBUTE_SAVE_ERROR:
            return { ...state, saving: false, error: true, conflict: !!action.conflict, stale: !!action.stale };
        case types.MELO_ATTRIBUTE_RESET_STATUS:
            return { ...initialState };
        default:
            return state;
    }
};

export default reducer;
